import script from "./contest.vue?vue&type=script&setup=true&lang=js"
export * from "./contest.vue?vue&type=script&setup=true&lang=js"

import "./contest.vue?vue&type=style&index=0&id=3141af9d&scoped=true&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3141af9d"]])

export default __exports__